"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYMENT_SOURCE = exports.PAYMENT_OPERATION = void 0;
var PAYMENT_SOURCE = exports.PAYMENT_SOURCE = "online_cc";
var PAYMENT_OPERATION = exports.PAYMENT_OPERATION = "auth";